import { AppSettings } from '../../models';
import { ConfigProvider } from './config-provider';
import { DefaultPinConfiguration } from '../../types';
import { Inject, Injectable } from '@angular/core';
import { LogService } from '../log/log.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigSettingsService {
  private _appSettings: AppSettings = ConfigSettingsService.getDefault();

  constructor(@Inject('appConfigs') private readonly configProviders: ConfigProvider[]) {
    this.configProviders = this.configProviders.sort(
      (cp1, cp2) => (cp1.loadOrder ? cp1.loadOrder : 100) - (cp2.loadOrder ? cp2.loadOrder : 100),
    );
  }

  public get appSettings(): AppSettings {
    return this._appSettings;
  }

  public async loadConfigProviders(): Promise<void> {
    let appSettings = ConfigSettingsService.getDefault();
    for (const configProvider of this.configProviders) {
      try {
        appSettings = await configProvider.getAppSettings(appSettings);
      } catch (error: unknown) {
        if (error instanceof Error) {
          LogService.error(error.message);
        }
      }
    }
    this._appSettings = appSettings;
  }

  private static getDefault(): AppSettings {
    return {
      constants: {
        maximumFileSizeInMb: 20,
        maximumAntragSizeInMb: 100,
        maximumAntragFilesLen: 255,
        minimumSeiteSizeInByte: 6000,
        antragsSizeInByteBeforeAsking: 6000000,
      },
      isMaintenance: false,
      personalNumberLength: 8,
      supportedOAuthGrants: new Set(['password']),
      customizing: {
        allowPdfUpload: false,
        firstBelegMandatoryConfig: {
          isActive: false,
          mandatoryPages: 0,
        },
        hasUebersicht: false,
        hasBescheide: false,
        hasUnfinishedAntrage: false,
        health: {
          timeout: 0,
        },
        ui: {
          app: {
            footer: {
              hasCustomBorder: false,
              hasCustomBackground: false,
            },
          },
        },
      },
      connection: {
        auth: '',
        res: '',
        clientId: '',
      },
      passwordRules: {
        minLength: 8,
        minHitPoints: -1,
        hitPointPerRule: 10,
        rules: [],
      },
      pinConfiguration: DefaultPinConfiguration,
      showDataPrivacyPage: false,
    };
  }
}
